<script setup lang="ts">
defineProps({
    blok: Object,
})

const localePath = useLocalePath()
</script>

<template>
    <section class="flex items-end relative pt-20 max-[641px]:block">
        <div class="w-full h-full absolute top-0 left-0">
            <img
                :src="blok?.background?.filename"
                alt="Scorecards"
                class="w-full h-full object-cover"
            >
        </div>
        <UiContainer>
            <div
                v-motion-slide-visible-once-top
                class="relative w-1/2 bg-chsc-indigo-500 p-20 rounded-t-[40px] max-[769px]:w-full max-[641px]:p-10"
            >
                <div class="global-text global-text--white text-center">
                    <StoryblokRichText :doc="blok?.header" />
                </div>
                <div class="flex justify-center mt-10">
                    <UButton
                        :to="localePath('/scorecards')"
                        :label="blok?.cta"
                        variant="outline"
                        color="secondary"
                        size="xl"
                    />
                </div>
            </div>
        </UiContainer>
    </section>
</template>
